import { render, staticRenderFns } from "./ProfileCreateProjectLink.vue?vue&type=template&id=5ea6afc0&scoped=true"
var script = {}
import style0 from "./ProfileCreateProjectLink.vue?vue&type=style&index=0&id=5ea6afc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea6afc0",
  null
  
)

export default component.exports